import React from 'react';
import { Box, Text, Grid, useBreakpointValue } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';

export default function Settings() {
  const history = useHistory();

  const gridTemplateColumns = useBreakpointValue({
    base: 'repeat(1, 1fr)',
    sm: 'repeat(2, 1fr)',
    md: 'repeat(3, 1fr)',
  });

  const handleNavigation = (path) => {
    history.push(path);
  };

  const cards = [
    {
      title: 'Gérez vos profils!',
      description: 'Créer et gérer les profils des pharmaciens/préparateurs',
      path: '/admin/profile',
    },
    {
      title: 'Gérez votre mot de passe master!',
      description: 'Définissez ou modifiez le mot de passe master.',
      path: '/admin/masterpass',
    },
    {
      title: 'Configuration des Points',
      description: 'Définissez ou modifiez les points attribués pour différents types de ventes.',
      path: '/admin/points-config',
    },
    {
      title: 'Gérez vos challenges!',
      description: 'Créer et gérer les challenges basés sur une période définie.',
      path: '/admin/challenges',
    },
    {
      title: 'Configuration Pro-Périmé',
      description: 'Personnalisez la période pro-périmé par produit de votre inventaire.',
      path: '/admin/config-pro-perime',
    },
    {
      title: 'Paramètres de conversion des points',
      description: 'Configurez la conversion des points en argent.',
      path: '/admin/points-conversion',
    }, 
    {
      title: 'Vente depuis Recherche Rapide',
      description: 'Activez ou désactivez la vente directement depuis la Recherche Rapide.',
      path: '/admin/quick-sell-config',
    },
  ];

  return (
    <Box mt="64px" px={4}>
      <Grid templateColumns={gridTemplateColumns} gap={6}>
        {cards.map((card, index) => (
          <Box
            key={index}
            p={6}
            borderWidth={1}
            borderRadius="xl"
            boxShadow="lg"
            cursor="pointer"
            transition="all 0.3s ease"
            _hover={{
              transform: 'scale(1.05)',
              boxShadow: '2xl',
              bg: 'gray.50',
            }}
            _active={{
              transform: 'scale(1)',
              bg: 'gray.100',
            }}
            onClick={() => handleNavigation(card.path)}
          >
            <Text fontSize="lg" fontWeight="bold" color="teal.500">
              {card.title}
            </Text>
            <Text fontSize="sm" color="gray.500">
              {card.description}
            </Text>
          </Box>
        ))}
      </Grid>
    </Box>
  );
}
